import React, { useEffect, useState } from "react";
import { SonicTermData } from "../classes/SonicTerm";
import styles from "./SelectTerm.module.scss";
import formStyles from "../../features/mypage/user_settings/EditBase.module.scss";
import adminStyles from "../../features/management/db-list/detail/DatabaseDetail.module.scss";
import SelectTermModal from "./SelectTermModal";
import { TermType, useGetTerm } from "../../utils/useTerm";
import SonicLink from "../routing/SonicLink";

type Props = {
  termType: TermType;
  termName: string;
  placeholder: string;
  term?: SonicTermData;
  handleTerm: (value?: SonicTermData) => void;
  isAdminPage?: boolean;
};
const SelectTerm: React.FC<Props> = ({
  termType,
  termName,
  placeholder,
  term,
  handleTerm,
  isAdminPage = false,
}) => {
  const [isModalShown, setIsModalShown] = useState<boolean>(false);

  const setModal = (value: boolean) => {
    const html = document.querySelector("html");
    if (html) {
      html.style.overflowY = value ? "hidden" : "unset";
    }

    setIsModalShown(value);
  };

  useEffect(() => {
    return () => {
      const html = document.querySelector("html");
      if (html) {
        html.style.overflowY = "unset";
      }
    };
  }, []);

  const selectHandler = (value: SonicTermData) => {
    handleTerm(value);
    setModal(false);
  };

  const [searchWord, setSearchWord] = useState<string>();

  const handleSearch = (keyword: string) => {
    setSearchWord(keyword ? keyword : undefined);
  };

  const {
    termData: { entries },
    getTermLoading,
  } = useGetTerm(termType, undefined, -1, searchWord);

  return (
    <>
      <div
        className={
          isAdminPage
            ? adminStyles["f-databaseDetail__form"]
            : formStyles["p-edit__form"]
        }
      >
        <div
          className={
            isAdminPage
              ? adminStyles["f-databaseDetail__form-title"]
              : formStyles["p-edit__form-title"]
          }
        >
          {termName}
        </div>
        {term ? (
          <div
            className={
              isAdminPage
                ? `${styles["select-term__select-btn"]} ${adminStyles["f-databaseDetail__form-input"]}`
                : `${styles["select-term__select-btn"]} ${formStyles["p-edit__form-input"]}`
            }
            onClick={() => {
              setModal(true);
            }}
          >
            {term?.name}
          </div>
        ) : (
          <div
            className={
              isAdminPage
                ? `${styles["select-term__select-btn"]} ${adminStyles["f-databaseDetail__form-input"]}`
                : `${styles["select-term__select-btn"]} ${formStyles["p-edit__form-input"]} ${formStyles["p-edit__form-input-novalue"]}`
            }
            onClick={() => {
              setModal(true);
            }}
          >
            {placeholder}
          </div>
        )}

        {!isAdminPage && (
          <div className={formStyles["p-edit__help"]}>
            {termName === "チーム" ? (
              <SonicLink to="/mypage/team-settings" newTab={true}>
                {"チームの新規登録はこちらから"}
              </SonicLink>
            ) : (
              <SonicLink to="/contact" newTab={true}>
                {`ご希望の${termName}がない方はこちら`}
              </SonicLink>
            )}
          </div>
        )}
      </div>
      <SelectTermModal
        isModalShown={isModalShown}
        isLoading={getTermLoading}
        termName={termName}
        handleSearch={handleSearch}
        handleClose={() => setModal(false)}
        handleSelect={selectHandler}
        handleDeselect={() => {
          handleTerm(undefined);
          setModal(false);
        }}
        selectedTerm={term}
        options={entries}
        helpLink={
          isAdminPage ? undefined : termName === "チーム" ? (
            <SonicLink to="/mypage/team-settings" newTab={true}>
              {"チームの新規登録はこちらから"}
            </SonicLink>
          ) : (
            <SonicLink to="/contact" newTab={true}>
              {`ご希望の${termName}がない方はこちら`}
            </SonicLink>
          )
        }
      />
    </>
  );
};

export default SelectTerm;
